/* ARVENTO stop planning and timestamp timer. No network or notification access. */
(function(global){
'use strict';
const KEY='arvento.bg360.stops.v1',MAX=1440;
function minutes(value){
 if(value===null||value===undefined)return null;
 const text=String(value).trim();if(!/^\d{1,4}$/.test(text))return null;
 const n=Number(text);return Number.isInteger(n)&&n<=MAX?n:null;
}
function summarize(ids,values){
 let known=0,missing=0;for(const id of ids){const n=minutes(values[id]);if(n===null)missing++;else known+=n;}
 return {complete:missing===0,total:missing?null:known,known,missing};
}
function start(id,label,value,now){
 const n=minutes(value);if(!id||n===null||n<1||!Number.isFinite(now))return null;
 return {id:String(id).slice(0,100),label:String(label).slice(0,160),state:'running',durationMs:n*60000,remainingMs:n*60000,deadline:now+n*60000};
}
function observe(timer,now){
 if(!timer)return null;
 if(timer.state!=='running')return {...timer};
 const remainingMs=Math.max(0,Math.min(timer.durationMs,timer.deadline-now));
 return {...timer,remainingMs,state:remainingMs===0?'expired':'running'};
}
function pause(timer,now){const t=observe(timer,now);return t?.state==='running'?{...t,state:'paused',deadline:null}:t;}
function resume(timer,now){return timer?.state==='paused'?{...timer,state:'running',deadline:now+timer.remainingMs}:observe(timer,now);}
function finish(){return null;}
function restoreTimer(value,now){
 if(!value||typeof value.id!=='string'||typeof value.label!=='string'||!['running','paused','expired'].includes(value.state))return null;
 if(!Number.isFinite(value.durationMs)||value.durationMs<60000||value.durationMs>MAX*60000||!Number.isFinite(value.remainingMs)||value.remainingMs<0||value.remainingMs>value.durationMs)return null;
 if(value.state==='running'&&!Number.isFinite(value.deadline))return null;
 const clean={id:value.id.slice(0,100),label:value.label.slice(0,160),state:value.state,durationMs:value.durationMs,remainingMs:value.state==='expired'?0:value.remainingMs,deadline:value.state==='running'?value.deadline:null};
 return observe(clean,now);
}
function planParams(plan,knownIds){
 const params=new URLSearchParams(),ids=new Set(knownIds),stops=[...new Set(plan.stops||[])].filter(id=>ids.has(id));
 params.set('stops',stops.join(','));params.set('speed',String(plan.speed));
 const values={};for(const id of knownIds){const n=minutes(plan.minutes?.[id]);if(n!==null)values[id]=String(n);}
 if(Object.keys(values).length)params.set('mins',JSON.stringify(values));
 return params;
}
function parsePlan(params,storeIds,knownIds){
 const allowed=new Set(storeIds),values=Object.create(null);let raw={};
 try{const parsed=JSON.parse(params.get('mins')||'{}');if(parsed&&typeof parsed==='object'&&!Array.isArray(parsed))raw=parsed;}catch{}
 for(const id of knownIds){if(!Object.prototype.hasOwnProperty.call(raw,id))continue;const n=minutes(raw[id]);if(n!==null)values[id]=String(n);}
 const speed=Number(params.get('speed'));
 return {stops:[...new Set((params.get('stops')||'').split(','))].filter(id=>allowed.has(id)),speed:Number.isFinite(speed)&&speed>=18&&speed<=32?speed:23,minutes:values};
}
function read(storage,now){
 try{const raw=storage.getItem(KEY);if(!raw)return {status:'ok',timer:null,plan:null};
  const saved=JSON.parse(raw);if(saved?.version!==1)return {status:'invalid',timer:null,plan:null};
  return {status:'ok',timer:restoreTimer(saved.timer,now),plan:saved.plan&&typeof saved.plan==='object'?saved.plan:null};
 }catch(error){return {status:error instanceof SyntaxError?'invalid':'blocked',timer:null,plan:null};}
}
function write(storage,value){try{storage.setItem(KEY,JSON.stringify({version:1,timer:value.timer,plan:value.plan}));return {status:'ok'};}catch{return {status:'blocked'};}}
// A timer action must not save an older tab's plan over a newer one.
function writeTimer(storage,timer,fallbackPlan){const current=read(storage,Date.now());return write(storage,{timer,plan:current.status==='ok'&&current.plan?current.plan:fallbackPlan});}
function writePlan(storage,plan,now,fallbackTimer=null){const current=read(storage,now),timer=current.status==='ok'?current.timer:fallbackTimer;return {...write(storage,{timer,plan}),timer};}
const api={KEY,minutes,summarize,start,observe,pause,resume,finish,restoreTimer,planParams,parsePlan,read,write,writeTimer,writePlan};
if(typeof module==='object'&&module.exports)module.exports=api;else global.Arvento360Stop=api;
})(globalThis);
